import { render, staticRenderFns } from "./age.vue?vue&type=template&id=811a496a&lang=pug&"
import script from "./age.vue?vue&type=script&lang=js&"
export * from "./age.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('811a496a')) {
      api.createRecord('811a496a', component.options)
    } else {
      api.reload('811a496a', component.options)
    }
    module.hot.accept("./age.vue?vue&type=template&id=811a496a&lang=pug&", function () {
      api.rerender('811a496a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/age.vue"
export default component.exports